module.exports = __webpack_public_path__ + "static/media/Sidebar-currency-protect-icon-inactive.824f8694.svg";